import { createFileRoute, notFound } from '@tanstack/react-router';
import { LegalDocument } from '~/components/sections/LegalDocument';
import { getLegalPageByFullPath } from '~/lib/payload';
import { pageHeadMeta } from '~/lib/seo';
import readingStylesHref from '~/styles/reading.css?url';

/**
 * Dynamic legal documents under `/terms/*` (Webflow URL paths preserved).
 * More specific siblings (e.g. `/terms/cookie`) take precedence over this splat.
 */
export const Route = createFileRoute('/terms/$')({
  loader: async ({ params }) => {
    const splat = params._splat?.replace(/^\/+|\/+$/g, '') ?? '';
    if (!splat || splat === 'cookie') {
      throw notFound();
    }
    const fullPath = `terms/${splat}`;
    const page = await getLegalPageByFullPath({ data: fullPath });
    if (!page) throw notFound();
    return { page };
  },
  head: ({ loaderData }) => {
    const page = loaderData?.page;
    if (!page) return {};
    const title = page.metaTitle?.trim() || `${page.title} – nsave`;
    const description =
      page.metaDescription?.trim() || `${page.title} for nsave products and services.`;
    const head = pageHeadMeta({
      title,
      description,
      path: `/${page.fullPath}`,
    });
    return {
      ...head,
      links: [...head.links, { rel: 'stylesheet', href: readingStylesHref }],
    };
  },
  component: LegalTermsSplatPage,
});

function LegalTermsSplatPage() {
  const { page } = Route.useLoaderData();
  return <LegalDocument page={page} />;
}
